const STORAGE_KEY = "zgai.console.filters.v1";

export interface PersistedFilters {
  keyword: string;
  category: string;
  theme: string;
  status: string;
}

export const DEFAULT_FILTERS: PersistedFilters = {
  keyword: "",
  category: "",
  theme: "",
  status: "",
};

/**
 * Spec §3.5 / §4.6: restore last-used filters from localStorage; fall back to
 * defaults on parse error, malformed shape, or vanished options.
 */
export function loadFilters(
  knownCategories: string[],
  knownThemes: string[],
  knownStatuses?: string[],
): PersistedFilters {
  if (typeof localStorage === "undefined") return { ...DEFAULT_FILTERS };
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return { ...DEFAULT_FILTERS };
  try {
    const parsed = JSON.parse(raw) as Partial<PersistedFilters>;
    const result: PersistedFilters = { ...DEFAULT_FILTERS };
    if (typeof parsed.keyword === "string") result.keyword = parsed.keyword;
    if (typeof parsed.category === "string" && knownCategories.includes(parsed.category)) {
      result.category = parsed.category;
    }
    if (typeof parsed.theme === "string" && knownThemes.includes(parsed.theme)) {
      result.theme = parsed.theme;
    }
    if (
      typeof parsed.status === "string" &&
      (parsed.status === "" || !knownStatuses || knownStatuses.includes(parsed.status))
    ) {
      result.status = parsed.status;
    }
    return result;
  } catch {
    return { ...DEFAULT_FILTERS };
  }
}

export function saveFilters(filters: PersistedFilters): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
}
